import { Injectable } from '@angular/core';

import * as moment from 'moment';

import { PlaylistResult } from '../models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlaylistService {

  constructor() { }

  buildArchiveURL(stationId: number, startDateTime: Date, duration: number): PlaylistResult {
    const utcDateTime = moment(startDateTime);

    const playlist = {
      baseURL: environment.streamUrl,
      'stationId': stationId,
      startDate: utcDateTime.utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
      duration: duration < 1 ? duration : Math.round(duration),
      includeMusic: stationId >= 9900 && stationId <= 9917 // Including music for all premier stations
    };

    return ({
      url: `${playlist.baseURL}/station/${playlist.stationId}/archive.m3u8?callingFromUI=true`
        + `&start=${playlist.startDate}`
        + `&duration=${playlist.duration}`
        + `&includeMusic=${playlist.includeMusic}`,
    });
  }

  buildArchiveURLWithSegmentId(stationId: number, segmentId: string): PlaylistResult {
    const playlist = {
      'baseURL': environment.streamUrl,
      'segmentId': segmentId,
      // 'includeMusic': stationId >= 9900 && stationId <= 9917 // Including music for all premier stations
    };

    return ({
      'url': `${playlist.baseURL}/segment/${playlist.segmentId}/archive.m3u8`
       // + `includeMusic=${playlist.includeMusic}`
    });
  }



  buildLiveURL(stationId: number): PlaylistResult {
      const playlist = {
        baseURL: environment.streamUrl,
        'stationId': stationId,
        includeMusic: true
      };

      return ({
        url: `${playlist.baseURL}/../v1/station/${playlist.stationId}/live.m3u8?`
          + `includeMusic=${playlist.includeMusic}`,
      });
  }

}
